import React, {useEffect} from 'react';
import {useAppDispatch} from '@hooks/app';
import {setBackendAvailable} from '@store/app.slice';
import {Loader} from '../Loader';
import {api} from '../../api';
import styles from './MaintenanceScreen.module.scss';

const HEALTH_CHECK_INTERVAL = 10000;

export const MaintenanceScreen = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const check = () => {
            api.get('/statistics', {timeout: 8000})
                .then(() => dispatch(setBackendAvailable(true)))
                .catch((error: any) => {
                    if (error?.response) {
                        dispatch(setBackendAvailable(true));
                    }
                });
        };

        check();
        const timer = setInterval(check, HEALTH_CHECK_INTERVAL);
        return () => clearInterval(timer);
    }, [dispatch]);

    return (
        <div className={styles.screen}>
            <Loader variant="error" size={5} style={{margin: '0 0 8px 0'}}/>
            <h1 className={styles.title}>Проводятся технические работы</h1>
            <p className={styles.subtitle}>
                Мы уже всё чиним. Пожалуйста, попробуйте позже.
            </p>
        </div>
    );
};
